/* eslint-disable */
import {getUserData} from '@/services/index';
import { store as starkStore} from '@ice/stark-data';
import {createModel} from 'ice';
import {  UserInfo,StringMapString, GroupInfo, StringMapArray  } from './perms_type';

let defaultState: UserInfo = {
    userName: '',
    userId: '',
    account: '',
    avatar: '',
    mobile: '',
    platform: '',
    perms: [] as Array<string>,
    pagePaths: [] as Array<string>,
    roles: [] as Array<string>,
    abilities: [] as Array<string>,
    apiPaths: [] as Array<string>,
    groupMapProduct: {} as StringMapArray,
    email: '',
    abilitieMap: {} as StringMapString,
    roleMap: {} as StringMapString,
    groupMap: {} as GroupInfo,
}
export default createModel({
    state:  defaultState,
    reducers: {
        setUserInfo(prevState, payload) {
            const newState = {
                ...prevState,
                ...(payload || {}),
            }
            starkStore.set('userInfo', newState);
            return newState;
        },
    },
    effects: () => ({
        //调用方式1：store.dispatch.user.asyncGetUserInfo();
        //调用方式2：
        //  const [userState, userDispatchers] = useModel('user');
        //  userDispatchers.asyncGetUserInfo();
        async asyncGetUserInfo() {
            let data = await getUserData();
            let groupMapProduct = {} as StringMapArray;
            Object.keys(data?.roleMap ||{}).forEach((roleId) => {
                //这里的roleId都要驼峰转下划线
                const roleIdLine = formatToLine(roleId);
                // 从符合这些格式的字符串中，提取group_id:mmt
                // dr:group:mmt_taxi_member, dr:group:mmt_dlv_member, dr:group:mmt_truck_member
                const strList = roleIdLine.split(':');
                if (strList.length === 3 && strList[0] === 'dr' && strList[1] === 'group' && strList[2].endsWith('_member')) {
                    const itemList = strList[2].split('_');
                    if (itemList.length === 3) {
                        const groupId = itemList[0];
                        const product = itemList[1];
                        if (groupId !=="") {
                            if (!groupMapProduct[groupId]) {
                                groupMapProduct[groupId] = groupMapProduct[groupId] || [];
                            }
                            groupMapProduct[groupId].push(product);
                        }
                    }
                }
            })
            this.setUserInfo({
                ...data,
                groupMapProduct: groupMapProduct,
            });
        },
    }),
});
const formatToLine = (value: string) => {
    return value.replace(/([A-Z])/g, '_$1').toLowerCase();
};
